import React, { useContext } from 'react';

import { Button } from '../';
import ScreenTextContext from '../../contexts/ScreenTextContext';

export const BackNextButtons = ({handleNext, handleBack, disableNext}) => {

  const { screenText } = useContext(ScreenTextContext);  

  if (!screenText || !screenText.setUp) {
    return ''; // Should return error? Loading?
  }
  
  const { back: backText, next: nextText } = screenText.global;
  
  return (
    <div className="btn-wrapper">

      <Button variant="secondary" onClick={handleBack} >
        {backText}
      </Button>

      <Button onClick={handleNext} disabled={disableNext}>
        {nextText}
      </Button>

    </div>
  )
}